// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3r-1";
export var rateTableServiceLevelDropdown = "_3r-3";
export var rateTableTypeDropdown = "_3r-0";
export var rateTableValueModeDropdown = "_3r-2";